import { array, object, schema, string } from "@anna-money/anna-web-lib/serializer";

export class AddressAutocompleteData extends schema(
  {
    id: string(),
    addressText: string(),
  },
  "AddressAutocompleteData",
) {}

export class AddressAutocompleteResponseData extends schema(
  {
    addresses: array(object(AddressAutocompleteData)),
  },
  "AddressAutocompleteResponseData",
) {}

export class ResolveAutocompleteData extends schema(
  {
    autocompleteId: string(),
  },
  "ResolveAutocompleteData",
) {}

export class ResolveAutocompleteResponseData extends schema(
  {
    premise: string().optional(),
    street: string().optional(),
    town: string().optional(),
    county: string().optional(),
    country: string().optional(),
    postcode: string().optional(),
  },
  "ResolveAutocompleteResponseData",
) {}
